export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="text-8xl font-bold text-primary-500 font-heading mb-4">404</div>
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-2">
          页面未找到
        </h1>
        <p className="text-foreground-600 text-sm mb-6">
          您访问的页面不存在或已被移除
        </p>
        <a
          href="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-line"></i>返回首页
        </a>
      </div>
    </div>
  );
}